import {LitElement} from 'lit';
import {store} from '@/store.js';

class AuthenticateCallback extends LitElement {
    firstUpdated() {
        store.dispatch({type: 'SIGNINCALLBACK'});
    }
}

customElements.define('authenticate-callback', AuthenticateCallback);
